import { getDescendantCodes } from "@l2r-front/l2r-utils"

import { useEquipmentTypes } from "../queries/equipment/useEquipmentsType"

export function useEquipmentDescendantCodes(code) {
    const { data: equipmentTypes } = useEquipmentTypes()

    return getDescendantCodes(code, equipmentTypes)
}